const RADIAN = Math.PI / 180;

type CustomizedLabelProps = {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
};

const MINIMUM_PERCENTAGE_TO_DISPLAY_SLICE_LABEL = 3;

export const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: CustomizedLabelProps) => {
  // Calculate the position for the label to be in the middle of the pie slice
  const radius = innerRadius + (outerRadius - innerRadius) * (percent >= 0.01 ? 0.5 : 0.6);
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const percentage = percent * 100;
  // If the percentage is greater than 1%, display 0 decimal places
  // If the percentage is less than 1%, display 2 decimal places
  // This avoids displaying "0%" for small values and provides easier visibility for big ones
  const numberOfDigitsAfterDot = percentage >= 1 ? 0 : 2;

  if (Math.round(percentage) < MINIMUM_PERCENTAGE_TO_DISPLAY_SLICE_LABEL) {
    return;
  }

  return (
    <text x={x} y={y} fill='white' textAnchor='middle' dominantBaseline='middle'>
      {percentage.toFixed(numberOfDigitsAfterDot)}%
    </text>
  );
};
